// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class BackButton extends Component {
  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.el.addEventListener(EventNames.CLICK, this.onClick);
  }

  /**
   * Execute when the button is clicked
   */
  onClick(): void {
    const referrer = document.referrer;
    const originUrl = window.location.origin;

    if ((referrer && referrer.includes(originUrl)) || window.history.state?.previousUrl) {
      window.history.back();
      return;
    }

    window.location.href = window.location.origin;
  }
}
